import { loginApi } from "src/api/taktileApi";

export const loginWithRefreshToken = async () => {
  return (await loginApi.authRefreshApiV1LoginRefreshPost()).data;
};
